import { inject, observer } from 'mobx-react';
import React, { ChangeEvent } from 'react';
import { Button, Toast, ToastType, Card, withStateCard } from '../../Components';
import { MonografiaStore, MONOGRAFIA_STORE, PROFESSOR_STORE, PREPROJETO_STORE, ProfessorStore, PreProjetoStore } from '../../Store';
import { MonografiasCard } from './Components/MonografiasCard';
import { RouteComponentProps } from 'react-router';
import { TabComponent, TabPanel } from '../../Components';
import { ConvitesList } from './Components/ConvitesList';
import { CHAT_STORE, ChatStore } from '../../Store/Chat';
import { OrientacaoList } from './Components/OrientacaoList';
import { PreProjetoList } from './Components/PreProjetoList';
import { apiState } from '../../Api';
import styled from 'styled-components';
import { withPages } from '../../Components/HOCs/withPages';
import Tutorial_Professor from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Professor.pdf";
import PageSubTitle from "../../Components/PageSubTitle";

interface IProps extends RouteComponentProps {
  [MONOGRAFIA_STORE]: MonografiaStore,
  [PROFESSOR_STORE]: ProfessorStore,
  [CHAT_STORE]: ChatStore,
  [PREPROJETO_STORE]: PreProjetoStore,
}

interface IState {
  value: string;
  abaAtual: string | null;
  notaOValida: boolean | undefined;
  notaCValida: boolean | undefined;
}

const Container: React.FC = (props: React.HTMLAttributes<HTMLDivElement>) => <>{props.children}</>;
const MonografiasCardWithState = withStateCard(MonografiasCard);
const ConvitesListWithState = withStateCard(ConvitesList);
const OrientacoesListWithPage = withPages(OrientacaoList);
const OrietacoesListWithStateWithPages = withStateCard(OrientacoesListWithPage);
const PreProjetosListWithState = withStateCard(PreProjetoList);
const CardWithState = withStateCard(Card);

const StyledTutorialButton = styled(Button)`
  margin-left: auto;
`;

@inject(MONOGRAFIA_STORE, PROFESSOR_STORE, CHAT_STORE, PREPROJETO_STORE)
@observer
export default class ListaMonografiasPage extends React.Component<IProps, IState>{
  tabRef: React.RefObject<TabComponent>;

  constructor(props: IProps) {
    super(props);

    this.state = {
      value: '',
      abaAtual: '',
      notaOValida: true,
      notaCValida: true,
    };

    this.tabRef = React.createRef<TabComponent>();
  }

  componentDidMount() {
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    const professorStore = this.props[PROFESSOR_STORE];
    const chatStore = this.props[CHAT_STORE];
    const preprojetoStore = this.props[PREPROJETO_STORE];

    monografiaStore.getMonografiasJaApresentadas();
    monografiaStore.getMonografiasFromProfessor();
    professorStore.getConvitesPendentes();
    professorStore.getConvitesAceitos();
    chatStore.getOrientacoes();
    preprojetoStore.getListaAlunosOrientacao();
    preprojetoStore.verificarSePeriodoDeAvaliacao()
    preprojetoStore.getFaseAtual()

    this.verificarSePeriodoDeAvaliacao()
  }

  alterarNota = async (monografiaId: number, notaO: number|undefined, 
    notaC: number|undefined, 
    obs: string|undefined,
    aut: boolean|undefined,
    ) => {
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    const { setValidationError } = monografiaStore
    setValidationError({});
    await monografiaStore.editarNotaMonografiaDoAluno(monografiaId,notaO,notaC,obs,aut)
    window.location.reload();
  }

  handleTextSelectChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    const monografiaStore = this.props[MONOGRAFIA_STORE];   
    monografiaStore.updateAttribute(name, value)
  }

  handleAutorizacaoSelectChange = (value: any) => {
    //const { name, value } = event.target
    const monografiaStore = this.props[MONOGRAFIA_STORE];   
    monografiaStore.update('monografia', 'autorizacaoProfessor', value)
    //monografiaStore.updateAttribute(name, value)
  }

  getMoreOrientacoes = () => {
    const store = this.props[CHAT_STORE];

    store.getOrientacoes(true);
  }

  onResumeClick = () => {
    window.open(Tutorial_Professor);
  }

  changePagePreProjeto = (change: number) => {
    const store = this.props[PREPROJETO_STORE];
    const { preProjetosListQuery } = store;

    store.updateObject(
      'preProjetosListQuery',
      'page',
      preProjetosListQuery.page + change
    );
    this.getPreProjetos();
  };

  getPreProjetos = () => {
    const store = this.props[PREPROJETO_STORE]
    store.getListaAlunosOrientacao();
  }

  getAbaAtiva = () => {
    this.tabRef.current && this.tabRef.current.forceUpdate(() => {
      this.setState({
        abaAtual: this.tabRef.current && this.tabRef.current.state.activeChild
      })
    })
  }

  verificarSePeriodoDeAvaliacao = async () => {
    const store = this.props[PREPROJETO_STORE]
    await store.verificarSePeriodoDeAvaliacao()
    const { periodoDeAvaliacao } = store

    this.setState({
      abaAtual: periodoDeAvaliacao ? 'Seleção de Orientandos' : 'Diário de Orientações'
    })
  }

  render() {
    const {
      [MONOGRAFIA_STORE]: monografiaStore,
      [PROFESSOR_STORE]: professorStore,
      [CHAT_STORE]: chatStore,
      [PREPROJETO_STORE]: preProjetoStore
    } = { ...this.props };
    const { monografias, todasMonografias, monografiaListState, todasMonografiasListState } = monografiaStore;
    const {
      agendamentoRealizado,
      resetAgendamento,
      convitesPendentes,
      convitesAceitos,
      conviteRespondido,
      convitesAceitosState,
      convitesPendentesState
    } = professorStore;
    const {
      orientacoesList,
      apiStates,
      carregouTodasOrientacoes
    } = chatStore;
    const {
      preProjetoList,
      orientandosState,
      preProjetoState,
      periodoDeAvaliacao,
      faseAtual,
      parametros
    } = preProjetoStore;
    const { notaOValida, notaCValida } = this.state;
    const setNotaOValida = (notaOValida: boolean) => this.setState({ notaOValida });
    const setNotaCValida = (notaCValida: boolean) => this.setState({ notaCValida });

    const handleNotaOSelectChange = (event: ChangeEvent<HTMLInputElement>) => {
      const { name, value } = event.target
      const value2 = value.replace(',','.')
      const formattedValue = Number(value2)
      setNotaOValida((/^[0-9]*(\,|\.)?[0-9]*$/.test(value2) || /^\d+$/.test(value2))
      && formattedValue <= 10 && formattedValue >= 0)
      const monografiaStore = this.props[MONOGRAFIA_STORE];   
      monografiaStore.updateAttribute(name, formattedValue)
    }

    const handleNotaCSelectChange = (event: ChangeEvent<HTMLInputElement>) => {
      const { name, value } = event.target
      const value2 = value.replace(',','.')
      const formattedValue = Number(value2)
      setNotaCValida((/^[0-9]*(\,|\.)?[0-9]*$/.test(value2) || /^\d+$/.test(value2))
      && formattedValue <= 10 && formattedValue >= 0)
      const monografiaStore = this.props[MONOGRAFIA_STORE];   
      monografiaStore.updateAttribute(name, formattedValue)
    }

    return (
      <Container>
        <PageSubTitle subTitle={this.state.abaAtual} />
        <StyledTutorialButton
          type="button"
          color="primaryLightColor"
          onClick={this.onResumeClick}
        >
          Tutorial de Uso
        </StyledTutorialButton>
        {agendamentoRealizado &&
          <Toast type={ToastType.success}>Agendamento solicitado</Toast>}

        {conviteRespondido &&
          <Toast type={ToastType.success}>Convite respondido</Toast>}

        <CardWithState state={preProjetoState === apiState.notFound ? apiState.done : preProjetoState}>
          <TabComponent ref={this.tabRef} onTabComponentClick={this.getAbaAtiva} activeChild={periodoDeAvaliacao ? 'Seleção de Orientandos' : 'Diário de Orientações'}>
            <TabPanel titulo='Diário de Orientações' badge={orientacoesList && orientacoesList.reduce((prev, curr) => curr.mensagensPendentes + prev, 0) + ''}>
              <OrietacoesListWithStateWithPages
                state={orientacoesList && orientacoesList.length > 0 ? apiState.done : apiStates.getOrientacoesState || apiState.loading}
                noContent='Nenhum diário de orientação foi encontrado'
                orientacoes={orientacoesList}
                loadMore={this.getMoreOrientacoes}
                loadState={apiStates.getOrientacoesState === apiState.noContent && orientacoesList && orientacoesList.length > 0 ? apiState.done : apiStates.getOrientacoesState || apiState.loading}
                height='400px'
                carregouTodasOrientacoes={carregouTodasOrientacoes}
              />
            </TabPanel>
            {periodoDeAvaliacao &&
              <TabPanel titulo='Seleção de Orientandos' badge={preProjetoList && preProjetoList.length.toString()}>
                <PreProjetosListWithState
                  state={orientandosState}
                  noContent='Nenhuma orientação pendente/atribuido a você para fase atual'
                  preprojetos={preProjetoList}
                  faseAtual={faseAtual}
                  parametros={parametros}
                />
              </TabPanel>
            }
            <TabPanel titulo='Depósitos de TCC' badge={monografias.length.toString()}>
              <MonografiasCardWithState
                state={monografiaListState}
                noContent='Nenhum depósito com ações pendentes'
                monografias={monografias}
                resetOnRedirect={resetAgendamento}
                atribuirNota={false}
              />
            </TabPanel>
            <TabPanel titulo='Convites Pendentes' badge={convitesPendentes.length.toString()}>
              <ConvitesListWithState
                state={convitesPendentesState}
                noContent='Nenhum convite com ações pendentes'
                convites={convitesPendentes}
              />
            </TabPanel>
            <TabPanel titulo='Convites Aceitos' badge={convitesAceitos.length.toString()}>
              <ConvitesListWithState
                state={convitesAceitosState}
                noContent='Nenhum convite aceito'
                convites={convitesAceitos}
                mostrarBotoes={false}
              />
            </TabPanel>
            <TabPanel titulo='Atribuir Notas' badge={todasMonografias.length.toString()}>
            <MonografiasCardWithState
                state={todasMonografiasListState}
                noContent='Nenhuma monografia com nota a ser atribuída'
                monografias={todasMonografias}
                resetOnRedirect={resetAgendamento}
                onTextChange={handleNotaOSelectChange}
                onTextNCChange={handleNotaCSelectChange}
                onTextObsChange={this.handleTextSelectChange}
                onAutorizacaoChange={this.handleAutorizacaoSelectChange}
                onAprovar={this.alterarNota}
                atribuirNota={true}
                notaOValida={notaOValida}
                notaCValida={notaCValida}
              />
            </TabPanel>
          </TabComponent>
        </CardWithState>
      </Container>
    );
  }
}